import { FETCH_CLIENTS,REMEDIATION_LIST, MODE_SETTING, GETING_DATA_BY_LOCALSTORAGE,REPORT_SETTING,PENDING_COUNT,REPORT_PANEL_FETCHED, SUMMARY_FETCHED, REPORT_DOWNLOAD, MAIN_SCREEN_SUMMARY_FETCHED, DASHBOARD_SUMMARY_FETCHED, VENDOR_SUMMARY_FETCHED } from "../actions";
const initialState = {
  clients: [],
  response: null,
  localClient: null,
  summary: null,
  mainSummary:null,
  reportDownload: false,
  dashboardSummary: [],
  reportPanelList: [],
  vendorSummary: [],
  loading: true,
  reportSetting:[],
  pendingCount:[],
  remediationList:[],
  modes:null
};

const summary = (state = initialState, action) => {
  switch (action.type) {
    case REMEDIATION_LIST:
      return{
        ...state,
        remediationList:action.payload
      }
      case MODE_SETTING:
        return{
          ...state,
          modes:action
        }
    case PENDING_COUNT:
      return{
        ...state,
        pendingCount:action.payload
      }
    case REPORT_SETTING:
      return{
        ...state,
        reportSetting:action.payload
      }
      case GETING_DATA_BY_LOCALSTORAGE:
        return {
          ...state,
          localClient: action.localClient,
        };
    case FETCH_CLIENTS:
      return {
        ...state,
        clients: action.clients,
        response: action.response,
      };
    case SUMMARY_FETCHED:
      return {
        ...state,
        summary: action.payload
      };
    case MAIN_SCREEN_SUMMARY_FETCHED:
      return {
        ...state,
        mainSummary: action.payload
      };
    case REPORT_DOWNLOAD:
      return {
        ...state,
        reportDownload: action.payload
      }
    case DASHBOARD_SUMMARY_FETCHED:
      return {
        ...state,
        dashboardSummary: action.payload,
        loading: action.payload ? false : true
      }
      case REPORT_PANEL_FETCHED:
        return {
          ...state,
          reportPanelList: action.payload,
          loading: action.payload ? false : true
        }
    case VENDOR_SUMMARY_FETCHED:
      return {
        ...state,
        vendorSummary: action.payload,
        loading: action.payload ? false : true
      }
    default:
      return state;
  }
};

export default summary;
